import { dateAtomToDate, LoanCriteria, LoanStatus } from '@nemuru-eng/js-api-client';

const COBORROWER_UNDER_MANAGEMENT_STATUS = [LoanStatus.STATUS_ANALYSING, LoanStatus.STATUS_DENIED];

export const isCoborrowerUnderManagement = (loan: LoanCriteria) => {
  const updatedAt = dateAtomToDate(loan.updatedAt) as Date;
  if (!isDateWithinNextDays(updatedAt, 10)) {
    return false;
  }

  if (!COBORROWER_UNDER_MANAGEMENT_STATUS.includes(loan.status)) {
    return false;
  }

  return (
    loan.coBorrowerOnboardingDetailsId !== null ||
    loan.guarantorOnboardingDetailsIds.length > 0 ||
    loan.coBorrowerId !== null ||
    loan.guarantorIds.length > 0
  );
};

export const numberOfCoborrowers = (loan: LoanCriteria) => {
  const newNumberOfCoborrowers =
    loan.guarantorOnboardingDetailsIds.length + (loan.coBorrowerOnboardingDetailsId !== null ? 1 : 0);
  const oldNumberOfCoborrowers = loan.guarantorIds.length + (loan.coBorrowerId !== null ? 1 : 0);
  return Math.max(newNumberOfCoborrowers, oldNumberOfCoborrowers);
};

const isDateWithinNextDays = (date: Date, days: number) => {
  const now = new Date();
  const futureDate = new Date();
  futureDate.setDate(now.getDate() + days);
  return date < futureDate;
};
